// extracted by mini-css-extract-plugin
export var circle = "_g2-1";
export var exitConfirmationModal = "_g2-5";
export var iframe = "_g2-0";
export var offline = "_g2-3";
export var online = "_g2-2";
export var workstationSelectError = "_g2-4";